<script setup lang="ts">
import { computed } from 'vue';
import { number } from 'vue-types';

import AgentLink from './AgentLink.vue';

import { type AgentQueryVariables, useAgentQuery } from '@/graphql/generated/graphql';

/** Agent id used for bulk implementation rollover (Created by / Last edited by = "System"). */
const SYSTEM_AGENT_ID = 210;

const props = defineProps({
  id: number(),
});

const isSystemAgent = computed(() => props.id === SYSTEM_AGENT_ID);

const variables = computed<AgentQueryVariables>(() => {
  if (props.id && !isSystemAgent.value) {
    return { id: props.id };
  }
  return undefined as unknown as AgentQueryVariables;
});

const {
  data: agent, fetching,
} = useAgentQuery({ variables, pause: computed(() => !variables.value) });
</script>
<template>
  <span v-if="isSystemAgent">System</span>
  <template v-else>
    <div v-if="fetching">
      ...Loading
    </div>
    <AgentLink v-else-if="agent?.agent" :agent="agent.agent" />
  </template>
</template>
